export const Stop = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.97 23.2207C6.04997 23.2207 1.21997 18.4007 1.21997 12.4707C1.21997 6.5407 6.04997 1.7207 11.97 1.7207C17.89 1.7207 22.72 6.5407 22.72 12.4707C22.72 18.4007 17.9 23.2207 11.97 23.2207ZM11.97 3.2207C6.86997 3.2207 2.71997 7.3707 2.71997 12.4707C2.71997 17.5707 6.86997 21.7207 11.97 21.7207C17.07 21.7207 21.22 17.5707 21.22 12.4707C21.22 7.3707 17.07 3.2207 11.97 3.2207Z" />
    <path d="M13.27 17.4502H10.73C8.20002 17.4502 7.02002 16.2702 7.02002 13.7402V11.2002C7.02002 8.67023 8.20002 7.49023 10.73 7.49023H13.27C15.8 7.49023 16.98 8.67023 16.98 11.2002V13.7402C16.98 16.2702 15.8 17.4502 13.27 17.4502ZM10.73 8.99023C9.04002 8.99023 8.52002 9.51023 8.52002 11.2002V13.7402C8.52002 15.4302 9.04002 15.9502 10.73 15.9502H13.27C14.96 15.9502 15.48 15.4302 15.48 13.7402V11.2002C15.48 9.51023 14.96 8.99023 13.27 8.99023H10.73Z" />
  </svg>
);
